import React from 'react'
import {
  Button,
  Divider,
  Group,
  NativeSelect,
  Stack,
  TextInput,
} from '@mantine/core'
import { useForm } from '@mantine/form'
import { useWidgetEditor } from './state'
import { COMPONENTS, STATISTIC } from './schemas'
import { useMetrics } from './api'

export function WidgetForm(props: { id: string }) {
  const editor = useWidgetEditor()
  const isSaving = editor.useIsSaving()
  const config = editor.useConfig(props.id)
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: structuredClone(config.options),
  })

  const metrics = useMetrics()

  const onSubmit = React.useCallback(
    (values: unknown) => {
      editor.setOptions(values)
      editor.save()
    },
    [editor]
  )

  const metricOptions = React.useMemo(() => {
    const m = metrics.data?.map((d) => ({
      value: d.key,
      label: d.name,
    }))
    return [{ value: '', label: '' }, ...m]
  }, [metrics])

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="sm">
        <Divider label="Data" />
        <NativeSelect
          {...form.getInputProps('metric')}
          label="Metric/KPI"
          size="md"
          data={metricOptions}
        />
        <Group grow>
          <NativeSelect
            {...form.getInputProps('component')}
            label="Component"
            data={COMPONENTS}
          />
          <NativeSelect
            {...form.getInputProps('statistic')}
            label="Statistic"
            data={STATISTIC}
          />
        </Group>
        <Divider label="Additional Options" />

        <TextInput {...form.getInputProps('title')} label="Title" />
      </Stack>

      <Group justify="flex-end" mt="md">
        <Button color="red.4" variant="outline" onClick={editor.endEditWidget}>
          Cancel
        </Button>
        <Button type="submit" loading={isSaving}>
          Save
        </Button>
      </Group>
    </form>
  )
}
